import * as rxjs from 'rxjs';
import { MapOfBehaviorSubjects } from './map-of-behavior-subjects';
interface GenericCompletable extends rxjs.Observable<any>{
	completeThis?:boolean;
	complete?():void;
}

export function completeProperties(o:Record<string,any>){
	for(const key in o){
		const prop=o[key];
		if(!prop)
			continue;
		if(prop instanceof MapOfBehaviorSubjects){
			prop.complete();
		}else if(prop instanceof rxjs.BehaviorSubject){
			prop.complete();
		}else if(prop instanceof rxjs.Subject && !(prop.source || (<any>prop).destination)){
			prop.complete();
		}else if(prop instanceof rxjs.Observable && typeof((<GenericCompletable>prop).complete)==='function' && (<GenericCompletable>prop).completeThis){
			(<GenericCompletable>prop).complete!();
		}
	}
}
